module.exports = __webpack_public_path__ + "a5df482844e38fdf0bdeb9ce66dfa71c.svg";